import { Link } from 'react-router-dom';

interface MangaCardProps {
  id: number;
  title: string;
  categoryName: string;
  category: string;
  cover: string;
  status: string;
  updateTime: string;
  views: number;
  rating: number;
}

export default function MangaCard({ id, title, categoryName, category, cover, status, updateTime, views, rating }: MangaCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return (v / 10000).toFixed(1) + '万';
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
            status === '连载中' ? 'bg-primary-500 text-background-50' : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
              {formatViews(views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill w-3 h-3 flex items-center justify-center text-accent-500"></i>
              {rating}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <div className="flex items-center justify-between mt-1.5">
          <Link
            to={`/category/${category}`}
            className="text-xs text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
            onClick={(e) => e.stopPropagation()}
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-500">{updateTime}</span>
        </div>
      </div>
    </Link>
  );
}